import { useEffect } from 'react';
import { Box } from '@comeon/ui';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrency, selectLocale } from '~/components/account/ducks/index.js';
import { Sidebar, SidebarFooter, SidebarHeader } from '~/components/sidebar/index.js';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';
import Icon, { ICON_CHECKMARK } from '~/components/icon/index.js';
import StartTime from '../components/start-time.js';
import WeSpinGameRoomNextSessionItem from './we-spin-game-room-next-session-item.js';
import { fetchParticipations } from '../ducks/we-spin-duck.js';
import IconButtonClose from '../../../misc/icon-button-close.js';
import { useCloseCurrentContext } from '~/hooks/use-close-context.js';
import { ROUTE_WE_SPIN_GAME_ROOM_PREVIEW } from '../constants/we-spin-route-constants.js';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';
import currencyFormatter from '../../../../libs/currency-formatter.js';

const SubTitleWhite = styled(SubTitle)`
	color: rgba(var(--we-spin-success-subtitle, var(--base-01)), 1);
`;

const IconButtonCloseWhite = styled(IconButtonClose)`
	svg {
		fill: rgba(var(--base-01), 1) !important;
	}
`;

export default function WeSpinGameRoomBuyInSuccess({ streamView, streamRef, resources, translations }) {
	const dispatch = useDispatch();

	const navigate = useNavigate();

	const onCloseSidebar = useCloseCurrentContext();

	useEffect(() => {
		dispatch(fetchParticipations());
	}, [dispatch]);

	const locale = useSelector(selectLocale);
	const playerCurrency = useSelector(selectCurrency);
	const transformPath = useContextualPathTransformer();

	const onNavigatePreview = () => {
		const link = transformPath(`${ROUTE_WE_SPIN_GAME_ROOM_PREVIEW}/${streamRef}`);
		navigate(link, { replace: true });
	};
	return (
		<div className="modal-view modal-view--sticky">
			<Sidebar>
				<SidebarHeader
					transparent
					Icon={<IconButtonCloseWhite onClick={onCloseSidebar} className="page-head__back" />}
				>
					<div className="page-head__right-side" />
				</SidebarHeader>
				<div className="u-mba u-flex-grow-1">
					<div className="u-text-c u-pt1 u-pb1">
						<HeadWrapper>
							<Icon type={ICON_CHECKMARK} />
							<MainTitle>You’re in!</MainTitle>
							<SubTitleWhite>{streamView.name}</SubTitleWhite>
							{!!streamView.buyInAmount && (
								<div className="u-mt2">
									<SubTitleWhite>My Buy-In</SubTitleWhite>
									<MainTitle>
										{currencyFormatter.format(streamView.buyInAmount, playerCurrency, locale)}
									</MainTitle>
								</div>
							)}
						</HeadWrapper>
					</div>
				</div>

				<SidebarFooter>
					<div className="u-pl1 u-pr1 u-pt2">
						<Box className="u-text-c">
							<SubTitleWhite>
								<StartTime state={streamView.state} start={streamView.start} joined />
							</SubTitleWhite>
						</Box>
						<Box my="5">
							<WeSpinGameRoomNextSessionItem
								locale={locale}
								stream={{
									...streamView,
									joined: true,
									isFreeWeSpin: false
								}}
								translations={translations}
								showGameIcon={false}
								onClick={e => {
									e.preventDefault();
									e.stopPropagation();
									onNavigatePreview();
								}}
								resources={resources}
							/>
						</Box>
					</div>
				</SidebarFooter>
			</Sidebar>
		</div>
	);
}
